import { green, grey } from '@mui/material/colors';

import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    actionScopes: {
      fontWeight: 700,
      margin: 'auto',
    },
    categoryValue: {
      margin: 'auto auto auto 5px',
    },
    categoryHeader: {
      display: 'flex',
      borderTop: `1px solid ${grey['300']}`,
      marginTop: '7px',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    },
    categoryHeaderRow: {
      display: 'flex',
    },
    table: {
      marginBottom: '10px',
    },
    categoryButton: {
      margin: 'auto 5px auto 0',
      padding: '2px 15px',
      fontSize: `${theme.typography.caption.fontSize}px`, // Theme fontSize type is number, SxProps expects string
      whiteSpace: 'nowrap',
    },
    approveButton: {
      background: green[400],
      '&:hover': { background: green[600] },
    },
    rejectButton: {
      background: grey[600],
      '&:hover': { background: grey[800] },
    },
    expandableIcon: {
      marginLeft: 0,
      cursor: 'pointer',
    },
    li: {
      padding: 0,
    },
  };
};
